// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#kb-related-articles h3[data-v-0aa3837f]{margin-top:50px;margin-bottom:12px}#kb-related-articles h6[data-v-0aa3837f]{margin-top:12px}#kb-related-articles ul[data-v-0aa3837f]{padding-left:0;margin-top:0;list-style-type:none}#kb-related-articles ul li[data-v-0aa3837f]{margin-top:1rem;font-size:14px}#kb-related-articles ul li[data-v-0aa3837f]:first-child{margin-top:0}", ""]);
// Exports
module.exports = exports;
